import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin-bottom: 15px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: ${({detailed}) => `repeat(${detailed ? 8 : 7}, 1fr)`};
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 5px;
`

/* Renderizado como `button`: o Bootstrap global dá borda, fundo e padding a botões. */
export const SortButton = styled(SubTitle)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0px;
  border: none;
  background: none;
  cursor: pointer;
`
